import React, { memo } from "react";
import { useSelector } from "react-redux";
import { MasterTemplate } from "../../../components/templates";
import Preload from "./Preload";
import RequireAuth from "./RequireAuth";
const PrivateSession = memo(props => {
  const isLoggedIn = useSelector(store => store.auth.isLoggedIn);
  return <RequireAuth>
      <Preload key="preload" isLoggedIn={isLoggedIn}>
        <MasterTemplate key="master" isLoggedIn={isLoggedIn}>
          {props.children}
        </MasterTemplate>
      </Preload>
    </RequireAuth>;
});
PrivateSession.propTypes = {};
export default PrivateSession;
